import './AboutContent.css'
import Fleet from './Fleet'
export default function AboutContent(){
    return(
        <div className="about-content">
            <h1 className="about-heading">Who we are</h1>
            <p>
                Friendly Transport Ltd. is a Birmingham-based HGV transport and logistics company, established in 2025. 
                Specializing in reliable freight solutions, we offer efficient haulage, fleet management, and logistics services across the UK. 
                With a commitment to punctuality, safety, and customer satisfaction, 
                We deliver tailored transport solutions to meet the evolving needs of businesses.
            </p>
            <br />
            
            <h1 className="about-heading">What we do</h1>
            <p>
                We offer expert transport services available across the whole UK with professional drivers and
                an efficient fleet at your disposal.
            </p>
            <br />

            <h1 className="about-heading">Our Specialisations</h1>
            <p>We have drivers trained in:</p>
            <ul>
                <li>ADR</li>
                <li>Waste</li>
            </ul>
            <p>For your specialised transport needs.</p>
            
            <br />
            <h1 className="about-heading">Our Fleet</h1>
            Below are the models that make up our fleet. We boast a total of 2 Vehicles and 2 Trailers.
            <Fleet />
        </div>
    )
}